import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { notificationActions } from '../../../../../store/notifications'
import Button from '../../../../common/Button'
import { unresolveProcodocsRequest } from '../../../../../lib/fetchApi'
import BodySimpleModalV3 from '../../../../common/modal/BodySimpleModalV3'

export default function RejectResolveRequest({request, refreshRequests}) {
    const [isLoading, setIsLoading] = useState(false)
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const caseId = useSelector(state => state.case.activeCase.case.id)
    async function rejectResolveRequestHandler() {
        setIsLoading(true)
        try {
            let unresolve = await unresolveProcodocsRequest(userToken, caseId, request.id)
            if (unresolve?.errorMessage) {
                dispatch(notificationActions.setError(unresolve))
            } else {
                if (refreshRequests) {
                    refreshRequests()
                }
            }
        } finally {
            setIsLoading(false)
        }
    }

    return <BodySimpleModalV3 message={'Reject Note'}>
        <Button title='Reject Note' color='btn_danger' btnStyle='btn_small' click={rejectResolveRequestHandler} isLoading={isLoading}><i className='ti ti-rosette-discount-check-off'></i></Button>
    </BodySimpleModalV3>
}